import classes from './FindDocs.module.css';

const FindDocs = () => {
    return (
        <div className={classes.wrapper}>
        </div>
    )
}

export default FindDocs;